import Card from "@pathwright/ui/src/components/card/Card"
import { FeatureAction, FeatureKey } from "@pathwright/graphql-client/src/generated"
import FeatureBlockList from "../../feature/block/FeatureBlockList"

const ManageAccountFeatures = ({ card }) => {
  return (
    <Card card={card} title="Configure Cohort communities">
      <FeatureBlockList
        key={FeatureAction.View}
        featureAction={FeatureAction.View}
        featureKeys={[
          FeatureKey.CohortActivityFeed,
          FeatureKey.CohortMemberDirectory
        ]}
      />
    </Card>
  )
}

ManageAccountFeatures.displayName = "ManageAccountFeatures"

export default ManageAccountFeatures
